import { useCallback, useMemo } from "react"

import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import EmptyComponent from "../../../../../Components/Empty"
import Table from "../../../../../Components/Table"
import Icon from "../../../../../Icon"
import { defaultColumns, getColumns, getDefaultColumn } from "./columns"

import "../webhooks.less"

const { Title, Text } = Typography

const events = {
  count: 2,
  results: [
    {
      id: "1",
      status: "succeeded",
      created_timestamp: "2023-10-05T10:20:30Z", //format need to be 9/22/25, 12:26:42 PM
      webhook_url:
        "https://dashboard.stripe.com/login?redirect=%2Facct_1Nahy6DJ7F4Tew2l%2Fwebhooks",
      status_code: "200 (OK)",
      response: "accepted"
    },
    {
      id: "2",
      status: "succeeded",
      created_timestamp: "2023-10-05T10:20:30Z", //format need to be 9/22/25, 12:26:42 PM
      webhook_url:
        "https://dashboard.stripe.com/login?redirect=%2Facct_1Nahy6DJ7F4Tew2l%2Fwebhooks",
      status_code: "200 (OK)",
      response: "accepted"
    },
    {
      id: "3",
      status: "failed",
      created_timestamp: "2023-10-05T10:20:30Z",
      webhook_url:
        "https://dashboard.stripe.com/login?redirect=%2Facct_1Nahy6DJ7F4Tew2l%2Fwebhooks",
      status_code: "200 (OK)",
      response: "accepted"
    }
  ]
}

const WebhookAttemptsTable = ({ attempts, onOrderingChange }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { filterWebhookAttempts } = useSelector((state) => state.publicApi)
  const { theme } = useSelector((state) => state.nav)
  // const count = events.count;
  // const pageSize = 10;
  // const results = events.results;
  const results = attempts || []
  // const [pageNumber, setPageNumber] = useState(1);

  const myColumns = defaultColumns

  const tableSettings = useMemo(
    () => ({
      scroll: {
        x: "auto"
        // y: 'calc(100vh - 72px - 24px - 32px - 24px - 43px - (16px + 32px + 16px))',
        // scrollToFirstRowOnChange: true,
      },
      // pagination: {
      //   total: count,
      //   current: pageNumber,
      //   pageSize: pageSize,
      // },
      locale: {
        emptyText: <EmptyComponent type="no_data_available" />
      }
    }),
    [
      // count, pageNumber
    ]
  )

  // function handleSelectRow(data, type) {
  //   if (type === 'add_event') {
  //     setModalType({type, data})
  //   }
  // }

  const handleChangeTable = useCallback((pagination, filters, sorter) => {
    let ordering = null
    if (sorter) {
      if (Array.isArray(sorter)) {
        ordering = sorter
          ?.map(({ field, order }) => (order === "ascend" ? field : `-${field}`))
          .join(",")
      } else {
        if (sorter.order) {
          ordering = sorter.order === "ascend" ? sorter.field : `-${sorter.field}`
        }
      }
    }
    onOrderingChange(ordering)
  }, [])

  const getTableColumns = useMemo(
    (type) => {
      let allColumns = getColumns({ theme })

      // const actionColumn = getActionColumn({
      //   onSelectRow: handleSelectRow
      // });

      return [
        ...myColumns
          .filter(({ active }) => active)
          .map((data) => allColumns?.[data.field_id] || getDefaultColumn({ ...data }))
        // ...(actionColumn ? [actionColumn] : [])
      ]
    },
    [theme]
  )

  // const updateData = () => {
  //   // // const serializeFilters = serializeData(filtersEvents);
  //   // const data = {
  //   //   // page: pageNumber,
  //   //   // page_size: pageSize,
  //   //   ordering,
  //   //   status: filterWebhookAttempts,
  //   // }
  //   // console.log('updateData', data)
  //   // dispatch(Creators.getEventRequest({...data}))
  //   updateData(ordering, filterWebhookAttempts)
  // }

  const openEventDetails = (eventData) => {
    if (eventData?.id) {
      navigate(`/developers/webhooks/events/${eventData?.id}`)
    }
  }

  return (
    <div style={{ marginTop: 16 }}>
      <div>
        <Table
          columns={getTableColumns}
          // loading={fetching}
          dataSource={results}
          scroll={tableSettings.scroll}
          onChange={handleChangeTable}
          // pagination={tableSettings.pagination}
          showSizeChanger={false}
          withOutPagination={true}
          locale={tableSettings.locale}
          rowHoverable={true}
          onRow={(record) => ({
            onClick: (event) => {
              openEventDetails(record)
            }
          })}
          className={"expanded-table"}
          expandable={{
            expandedRowRender: (record) => (
              <div style={{ width: "50%" }}>
                <Flex justify="space-between">
                  <Text type="secondary">HTTP status code:</Text>
                  <Text> {record.response_status || "—"}</Text>
                </Flex>
                <Flex vertical style={{ marginTop: 16 }}>
                  <Text type="secondary">Response</Text>
                  <div className="response-wrapper">
                    <Text>{record.response_body || record.error_message || "—"}</Text>
                  </div>
                </Flex>
              </div>
            ),
            rowExpandable: (record) =>
              Boolean(record.response_status || record.response_body || record.error_message),
            expandIcon: ({ expanded, onExpand, record }) =>
              expanded ? (
                <Icon
                  type="arrow_select_down"
                  style={{ transition: "0.3s ease" }}
                  onClick={(e) => onExpand(record, e)}
                />
              ) : (
                <Icon
                  type="arrow_select_down"
                  style={{ transform: "rotate(180deg", transition: "0.3s ease" }}
                  onClick={(e) => onExpand(record, e)}
                />
              ),
            expandRowByClick: true
          }}
        />
      </div>
    </div>
  )
}

export default WebhookAttemptsTable
